export const env = {
  API_URL: import.meta.env.VITE_API_URL as string,
  IMAGE_URL: import.meta.env.VITE_IMAGE_URL as string,
  APP_NAME: import.meta.env.VITE_APP_NAME as string,
  APP_TAG_LINE: import.meta.env.VITE_APP_TAG_LINE as string,
  SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL as string,
  STORE_PAGE_ENABLED: import.meta.env.VITE_STORE_PAGE_ENABLED == 'true',
  CHECKOUT_PROMO_CODE_ENABLED:
    import.meta.env.VITE_CHECKOUT_PROMO_CODE_ENABLED == 'true',
  EMAIL_LIST_SIGNUP_ENABLED:
    import.meta.env.VITE_EMAIL_LIST_SIGNUP_ENABLED == 'true',
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: import.meta.env
    .VITE_NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string,
  EMAIL_SIGNUP_POPUP_SHOW_AFTER_MS: parseInt(
    import.meta.env.VITE_EMAIL_SIGNUP_POPUP_SHOW_AFTER_MS || '172800000' // 2 days default
  ),
  EMAIL_SIGNUP_CARD_SHOW_AFTER_MS: parseInt(
    import.meta.env.VITE_EMAIL_SIGNUP_CARD_SHOW_AFTER_MS || '7200000' // 2 hours default
  ),
  EMAIL_SIGNUP_SUCCESS_HIDE_MS: 7 * 24 * 60 * 60 * 1000, // 7 days
  RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY as string,
  MAILING_ADDRESS: import.meta.env.VITE_MAILING_ADDRESS as string,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
} as const;

// Validate environment variables
const requiredEnvVars = [
  'API_URL',
  'IMAGE_URL',
  'APP_NAME',
  'SUPPORT_EMAIL',
  'NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY',
  'MAILING_ADDRESS',
] as const;
for (const envVar of requiredEnvVars) {
  if (!env[envVar]) {
    throw new Error(`Missing required environment variable: VITE_${envVar}`);
  }
}
